export const defaultPassword = 'dancebox&123';
// 以字母开头，长度在6-20之间，只能包含数字、字符
export const usernameReg = /^(([a-zA-Z\d+])|(\.|_)){6,20}$/;
// 手机号码正则
export const mobileReg = /^1[3456789]\d{9}$/;
// 邮箱规则
export const emailReg = /^([a-zA-Z0-9_-]|\.)+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
// 价格的正则
export const priceReg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
